import {computed, ref, watch} from 'vue';
import { validateFormFields } from '@/components/contact-view/ownerform';
import * as yup from 'yup';

export const useFormField = function<T>(defaultValue: T, schema: yup.AnySchema) {
        const value = ref<T>(defaultValue)
        const error = ref<string|null>('')

        watch(value, () => {
            validate();
        }, {deep: true})

        const validate = async () => {
            error.value = await validateFormFields(value.value, schema)
        }

        const isValid = computed(() => {
            return error.value === null;
        })

        const reset = () => {
            value.value = defaultValue;
            error.value = '';
        }

        return {value, isValid, error, validate, reset};
}